import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './photo-examples.scss';

export const photoExamples: Record<string, { count: number; page: number; guidance: string }> = {
  FOTO_PADRAO_ENTRADA: { count: 6, page: 4, guidance: 'Mostre o padrão inteiro e o local ao redor. Os exemplos incluem fotos amplas e próximas do padrão.' },
  FOTO_PADRAO_DISJUNTOR: { count: 4, page: 5, guidance: 'Mostre o disjuntor do padrão de entrada de forma que seja possível ler a corrente nominal.' },
  FOTO_FACHADA_PADRAO: { count: 4, page: 7, guidance: 'A frente da edificação e o padrão de entrada devem aparecer na mesma foto.' },
  FOTO_QUADRO_INTERNO: { count: 3, page: 9, guidance: 'Se existir quadro interno, mostre o quadro e seus disjuntores com nitidez.' },
  FOTO_LOCAL_INVERSOR: { count: 5, page: 10, guidance: 'Faça uma foto ampla do local onde o inversor será instalado. Prefira um local coberto e próximo ao padrão de entrada.' },
  FOTO_TELHADO: { count: 6, page: 12, guidance: 'Fotografe o telhado visto de baixo. Não suba no telhado para tirar as fotos. Confirme também o tipo de estrutura com o cliente.' }
};

export default function PhotoExamples({ category, label }: { category: string; label: string }) {
  const [show, setShow] = useState(false);
  const examples = photoExamples[category];
  if (!examples) return null;
  const publicUrl = process.env.PUBLIC_URL || '';
  const titleId = `viability-examples-title-${category}`;
  return <>
    <button type="button" className="btn btn-outline-secondary me-2" onClick={() => setShow(true)}
      aria-label={`Ver modelos de fotos: ${label}`} aria-haspopup="dialog">Ver modelos de fotos</button>
    <Modal show={show} onHide={() => setShow(false)} size="lg" centered scrollable animation={false} className="viability-photo-examples-modal"
      aria-labelledby={titleId} backdropClassName="viability-photo-examples-backdrop" style={{ zIndex: 1080 }}>
      <Modal.Header closeButton closeLabel="Fechar modelos de fotos">
        <Modal.Title id={titleId}>Modelos: {label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{examples.guidance}</p>
        <p className="text-muted">Exemplos do manual orientativo. Use-os como referência para fotografar o local da instalação.</p>
        <div className="row g-3">
          {Array.from({ length: examples.count }, (_, index) => {
            const src = `${publicUrl}/viability-examples/${category.toLowerCase()}-${String(index + 1).padStart(2, '0')}.jpg`;
            return <figure className="col-12 col-sm-6 mb-0" key={src}>
              <img src={src} alt={`Modelo ${index + 1}: ${label}`} className="viability-photo-example border rounded" loading="lazy" />
              <figcaption className="small text-muted mt-1">Exemplo {index + 1}</figcaption>
            </figure>;
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <a className="btn btn-link" href={`${publicUrl}/manual-viabilidade.pdf#page=${examples.page}`} target="_blank" rel="noopener noreferrer">Ver no manual completo</a>
        <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>Fechar modelos</button>
      </Modal.Footer>
    </Modal>
  </>;
}
